import { LocationModel, PpaModel } from '../ngrx-store/app.state'
import { titleCase } from './sale.util'

/** "Ikeja, Lagos" - or just the part it has (older locations can lack a state), with no stray comma. */
export function ppaPlace(location: LocationModel | null | undefined): string {
  // States are stored upper case ('ABIA').
  const state = location?.State?.name && titleCase(location.State.name)
  return [location?.StateLGA?.name, state].filter(Boolean).join(', ')
}

/** An icon for what kind of PPA it is - shown when it has no photos. */
export function ppaTypeIcon(type: string | null | undefined): string {
  const lower = (type ?? '').toLowerCase()
  if (lower.includes('school')) return 'school'
  if (lower.includes('bank')) return 'account_balance'
  if (lower.includes('hospital') || lower.includes('health')) return 'local_hospital'
  if (lower.includes('ngo')) return 'volunteer_activism'
  if (lower.includes('government')) return 'domain'
  return 'business'
}

/** The houses search near a PPA - the place houses_nearby_count counts: its primary location's LGA. */
export function housesNearPpaQueryParams(ppa: Pick<PpaModel, 'Locations'>): Record<string, string> {
  const location = ppa.Locations?.[0]
  return {
    tab: 'accommodation',
    ...(location?.State?.name && { state: location.State.name.toUpperCase() }), // the search page's state options are upper case
    ...(location?.StateLGA?.name && { lga: location.StateLGA.name }),
  }
}

/** The public link to a PPA - what Share sends. */
export function ppaUrl(ppa: Pick<PpaModel, 'id' | 'slug_id'>): string {
  return `${window.location.origin}/ppa/${ppa.slug_id ?? ppa.id}`
}

/** How PPA lists are laid out from `sm` up - the /ppa toggle, remembered on this device. Phones always get rows. */
export type PpaView = 'list' | 'grid'

const PPA_VIEW_STORAGE_KEY = 'ppa_page_view'

/** Below Tailwind's `sm`: PPAs as compact rows (the card's `layout="row"`). */
export const PPA_PHONE_QUERY = '(max-width: 639.98px)'

export function readPpaView(): PpaView {
  try {
    return localStorage.getItem(PPA_VIEW_STORAGE_KEY) === 'grid' ? 'grid' : 'list'
  } catch {
    return 'list'
  }
}

export function savePpaView(view: PpaView): void {
  try {
    localStorage.setItem(PPA_VIEW_STORAGE_KEY, view)
  } catch {
    // Private mode etc. - it just won't be remembered.
  }
}

/** The classes for a list of PPA cards - the same on /ppa and in search. */
export function ppaListClass(isPhone: boolean, view: PpaView): string {
  if (isPhone) return 'flex flex-col gap-2'
  return view === 'list'
    ? 'flex flex-col gap-3 max-w-4xl mx-auto'
    : 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 lg:gap-6'
}
